import React from 'react';
import type { ComplianceSummary } from '@/types/api';

interface ComplianceBadgeProps {
  compliance: ComplianceSummary;
  size?: 'sm' | 'md' | 'lg';
}

export function ComplianceBadge({ compliance, size = 'md' }: ComplianceBadgeProps) {
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const getColorClasses = (score: number) => {
    if (score === 100) return 'bg-green-100 text-green-700 border-green-200';
    if (score >= 75) return 'bg-yellow-100 text-yellow-700 border-yellow-200';
    if (score >= 50) return 'bg-orange-100 text-orange-700 border-orange-200';
    return 'bg-red-100 text-red-700 border-red-200';
  };

  return (
    <div className={`inline-flex items-center gap-2 rounded-full border ${sizeClasses[size]} ${getColorClasses(compliance.score)}`}>
      <span className="text-lg leading-none">{compliance.emoji}</span>
      <span className="font-medium">
        {compliance.score}%
      </span>
      <span className="text-xs opacity-75">
        ({compliance.submittedCount}/{compliance.total})
      </span>
    </div>
  );
}